goog.provide('el8.appshared.listeditorOpts');

goog.require('el8.data.icd9Codes');
goog.require('el8.data.snomedCodes');


el8.appshared.listeditorOpts = {
    
    icd9Codes: function() {
        return {
            editFriendly: true,
            labelType: 'medium',
            convertTextToItemFn: function(code) {
                var icd9 = el8.data.icd9Codes.getByKey(code);
                return icd9 || null;
            },
            handleStringEntryFn: function(val) {
                el8.uiwidget.alert("Please select ICD-9s from the autocomplete.");
            },
            getItemTextFn: function(item) { return item.getCode(); },
            getItemDisplayOnlyTextFn: function(item) {
                if (!item) { return ' - INVALID'; }
                var displayText = (item.getDescription()) ?
                    item.getCode() + ' - ' + item.getDescription() :
                    item.getCode() + ' - ' + 'INVALID';
                return displayText;
            },
            getItemIdFn: function(item) { return item.getId(); }
        };
    },

    snomedCodes: function() {
        return {
            editFriendly: true,
            labelType: 'medium',
            convertTextToItemFn: function(code) {
                var snomed = el8.data.snomedCodes.getByKey(code);
                return snomed || null;
            },
            handleStringEntryFn: function(val) {
                el8.uiwidget.alert("Please select Snomeds from the autocomplete.");
            },
            getItemTextFn: function(item) { return item.getCode(); },
            getItemDisplayOnlyTextFn: function(item) {
                if (!item) { return ' - INVALID'; }
                var displayText = (item.getDescription()) ?
                    item.getCode() + ' - ' + item.getDescription() :
                    item.getCode() + ' - ' + 'INVALID';
                return displayText;
            },
            getItemIdFn: function(item) { return item.getId(); }
        };
    },

    medicalSpecialties: function() {
        return {
            editFriendly: false,
            labelType: 'none',
            getItemTextFn: function(item) { return item ? item.name : ''; },
            getItemIdFn: function(item) { return item ? item.id : null; },
            mindreaderOpts: $.extend(el8.appshared.mindreaderOpts.medicalSpecialties(), {
                formatSelected: function(item) { return ''; }
            })
        };
    },

    labOrderTests: function() {
        return {
            editFriendly: true,
            labelType: 'medium',
            // 'item' will be a LabOrderTest in the two functions below,
            // because a set will already have been broken out into a series
            // of tests before being added to the LE
            getItemTextFn: function(item) {
                return item.getNameWithCode();
            },
            getItemIdFn: function(item) { return item.getId(); }
        };
    },

    practiceUsers: function() {
        return {
            editFriendly: false,
            getItemTextFn: function(item) { return item.getFullName(); },
            getItemIdFn: function(item) { return item.getId(); },
            handleStringEntryFn: function(val) {
                el8.uiwidget.alert("Please select a user from the autocomplete.");
            }
        };
    },

    practiceUsersAndStaffGroups: function() {
        return {
            editFriendly: false,
            getItemTextFn: function(item) {
                if (item.getModelClass() === 'User') { // User is not an el8Id
                    return item.getFullName();
                } else if (el8.model.idToModelClass(item.getId()) === 'StaffGroup') {
                    return item.getName() + ' (Group)';
                }
            },
            getItemIdFn: function(item) { return item.getId(); },
            handleStringEntryFn: function(val) {
                el8.uiwidget.alert("Please select a user or group from the autocomplete.");
            }
        };
    }
};